import {Dispatch} from 'redux';
import {EnhancedErrorHandler} from '../types';

export const createAggregateErrorHandler = (
  dispatch: Dispatch,
  ...errorHandlers: (EnhancedErrorHandler | undefined)[]
): ((error: Error) => void) => {
  return (error: Error) => {
    console.log('General error handler', JSON.stringify(error));
    const unhandledError = errorHandlers.reduce<Error | undefined>(
      (reducedError?: Error, eh?: EnhancedErrorHandler) =>
        reducedError && eh ? eh(reducedError, dispatch) : reducedError,
      error,
    );
    if (unhandledError) {
      console.log('General error handler: throw unhandled');
      throw unhandledError;
    }
  };
};
